module.exports = __webpack_public_path__ + "img/symbol_4.99aa4cef.png";